import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './layout/navbar/Navbar';
import Footer from './layout/footer/Footer';
import Header from './layout/header/header';
import Home from './pages/Home';
import Day from './pages/Day';
import SkillQuest from './pages/SkillQuest';
import Contact from './pages/Contact';
import DialogueSessions from './pages/DialogueSessions';
import Workshops from './pages/Workshops';
import Rate from './pages/Rate';
import CareerGuidance from './pages/CareerGuidance';
function App() {
  return (
    <div className="App min-h-screen bg-slate-50 text-slate-900">
      <BrowserRouter>
        <Navbar />
        <Header />
        <div className='min-h-screen'>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/day" element={<Day />} />
            <Route path="/skill-quest" element={<SkillQuest />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/dialogue-sessions" element={<DialogueSessions />} />
            <Route path="/workshops" element={<Workshops />} />
            <Route path="/career-guidance" element={<CareerGuidance />} />
            <Route path="/rate" element={<Rate />} />
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
